var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.visible)?_c('ul',{ref:"contextmenu",staticClass:"contextmenu",style:({left:this.styleobj.left+'px',top:this.styleobj.top+'px'})},[_c('li',{on:{"click":function($event){return _vm.setopacity()}}},[_vm._v("设置透明度")])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fcdc930","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/plugins/app/assembly/kyyzt/RightMenu.vue
// module id = null
// module chunks = 